import React from 'react'
import styled from 'styled-components'

const MediaContainer = styled.div`
  border: 1px solid ${props => (props.theme.colors.fg)};
  background-color: ${props => (props.theme.colors.bg2)};
  position: relative;
  width: 100%;
  overflow: hidden;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
  ${props => (props.theme.shadow)}
  margin-top: 20px;
  @media (max-width: ${props => (props.theme.breaks.mobile)}px) {
    margin-top: 0px;
  }

`;
const InnerBox = styled.div`
  position:  absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;
const MediaSubText = styled.div`
  text-align: right;
  margin-top:10px;
  margin-bottom:50px;
  @media (max-width: ${props => (props.theme.breaks.mobile)}px) {
    margin-bottom: 20px;
  }
`


export default class MediaBox extends React.Component {
/*
  state = { count: 0 }

  increment = () => this.setState({ count: this.state.count + 1 });
  decrement = () => this.setState({ count: this.state.count - 1 });
*/

  render() {
    return (
      <div>
        <MediaContainer onClick={this.increment}>
          <InnerBox>
            {this.props.children}
          </InnerBox>
        </MediaContainer>
        <MediaSubText>{this.props.subText}</MediaSubText>
      </div>
    )
  }
}
